<ng-template #fileLibraryContent>
  <div class="flex flex-col h-full overflow-auto">
    @if (showFileLibrarySig()) {
    <nrc-file-library-modal-search
      class="flex flex-1 min-h-0 w-full"
      [isFileListLoading]="isFileListLoading"
      [fileListItemsSig]="fileListItemsSig"
      [metaSig]="metaSig"
      (fileListEvent)="fileListEvent.emit($event)"
      (fileSearchEvent)="fileSearchEvent.emit($event)"
      (actionButtonEvent)="showFileLibrarySig.set(false)"
      (fileSelectedEvent)="currentFile = $event.item?.value"
    />
  } @else {
    <nrc-file-library-modal-selector
      class="flex w-full overflow-auto grow"
      [currentFile]="currentFile"
      [acceptableMimeTypes]="acceptableMimeTypes"
      (showFileLibraryEvent)="toggleShowFileLibrary()"
      (fileUploadEvent)="fileUploadEvent.emit($event)"
    />
  }

    <hr class="h-[1.5px] my-6 bg-white/5 border-none flex-shrink-0">

    <!-- The footer - includes button to pass current item on close of the modal -->
    <nrc-file-library-modal-footer
      class="w-full h-10 flex-shrink-0"
      [showFileLibrary]="showFileLibrarySig()"
      [hideSelection]="hideSelection"
      (backEvent)="toggleShowFileLibrary()"
      (closeEvent)="closeModal(currentFile)"
    />
  </div>
</ng-template>
